const initialstate = {
  sportRequestsData: [],
  lastDoc: "",
  hasMoreSportRequests: true,
  isFetchingSportRequests: false,
};
const requestCitiesReducer = (state = initialstate, action) => {
  switch (action.type) {
    case "FETCH_SPORT_REQUESTS_PENDING":
      return {
        ...state,
        isFetchingSportRequests: true,
        error: null,
      };
    case "FETCH_SPORT_REQUESTS_SUCCESS":
      return {
        ...state,
        sportRequestsData: action.payload.sportRequestsData,
        lastDoc: action.payload.lastDoc,
        hasMoreSportRequests: action.payload.hasMoreSportRequests,
        isFetchingSportRequests: false,
      };
    case "FETCH_SPORT_REQUESTS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        sportRequestsData: [
          ...state.sportRequestsData,
          ...action.payload.sportRequestsData,
        ],
        lastDoc: action.payload.lastDoc,
        hasMoreSportRequests: action.payload.hasMoreSportRequests,
        isFetchingSportRequests: false,
      };
    case "FETCH_SPORT_REQUESTS_REJECTED":
      return {
        ...state,
        isFetchingSportRequests: false,
        error: action.error,
      };
    default:
      return {
        ...state,
      };
  }
};
export default requestCitiesReducer;
